// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lined{
    text-decoration: line-through;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/programas/programas.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC","sourcesContent":[".lined{\n    text-decoration: line-through;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
